<template>
<div class="plan-section">
  <plan-summary-line :name="name" :amount="plan.monthlyTarget" show-menu-item @plan-menu-clicked="onMenuClicked"/>
  <div v-if="showEditPlanSection" class="edit-plan-section" @click="$emit('edit-plan-click')">
    <div class="edit-icon">
      <icon icon-name="visibility" :color="editIconColor"/>
    </div>
    <span class="text">לצפיה בתוכנית</span>
  </div>
</div>
</template>

<script>
import moment from 'moment';
import BaseUi from 'base-ui';
import Segment from '@/Segment';
import PlanSummaryLine
  from './PlanSummaryLine';

export default {
  name: 'PlanSection',
  components: {
    PlanSummaryLine,
    Icon: BaseUi.Icon,
  },
  data() {
    return {
      showEditPlanSection: false,
      editIconColor: BaseUi.Colors.riseupWhite,
    };
  },
  props: {
    plan: {
      type: Object,
      require: true,
    },
  },
  computed: {
    name() {
      return `${this.plan.name} ב${this.month}`;
    },
    month() {
      return moment(this.plan.deadline).locale('he').format('MMMM');
    },
  },
  methods: {
    onMenuClicked() {
      this.showEditPlanSection = !this.showEditPlanSection;
      Segment.trackUserInteraction('PlanAhead_Section_MenuClicked', { isOpen: this.showEditPlanSection });
    },
  },
};
</script>

<style scoped lang="scss">
@import '~base-ui/src/scss/riseup-colors';

.plan-section {
  background: #F1F1F1;
  border-bottom: 1px solid white;

  .edit-plan-section {
    cursor: pointer;
    height: 60px;
    background: $riseup_gray_2;
    display: flex;
    align-items: center;
    padding-right: 28px;

    .edit-icon {
      padding-left: 6px;
      cursor: pointer;
    }

    .text {
      color: $riseup_white;
      font-weight: bold;
      font-size: 14px;
    }
  }
}
</style>
